"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var isNavType_1 = require("react-sidenav/nav/isNavType");
var createNavItemProp_1 = require("react-sidenav/nav/createNavItemProp");
var constants_1 = require("react-sidenav/constants");
var NavItem_1 = require("react-sidenav/nav/NavItem");
var NavItemWithChildren_1 = require("react-sidenav/nav/NavItemWithChildren");
var Context_1 = require("react-sidenav/Context");
var NavRenderer = /** @class */ (function (_super) {
    __extends(NavRenderer, _super);
    function NavRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderNavView = function (context) {
            var childrenArr = React.Children.toArray(_this.props.children);
            var nonNavChildren = childrenArr.filter(function (child) { return !isNavType_1.isNavType(child); });
            var navChildren = childrenArr.filter(isNavType_1.isNavType);
            var navItemProp = createNavItemProp_1.createNavItemProp(_this.props.navProp, context.theme, context.template, context.selectedPath, constants_1.PATH_SEPARATOR, _this.props.parentPathId, context.scheme);
            var parentPathId = _this.props.navProp.id;
            if (navChildren.length === 0) {
                return (React.createElement(NavItem_1.NavItem, __assign({}, navItemProp, { context: context, isLeaf: true }), _this.props.children));
            }
            else {
                return (React.createElement(NavItemWithChildren_1.NavItemWithChildren, __assign({ nonNavChildren: nonNavChildren }, navItemProp, { parentPathId: parentPathId, context: context, isLeaf: false }), navChildren));
            }
            return null;
        };
        return _this;
    }
    NavRenderer.prototype.render = function () {
        return (React.createElement(Context_1.Consumer, null, this.renderNavView));
    };
    return NavRenderer;
}(React.Component));
exports.NavRenderer = NavRenderer;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-sidenav/nav/NavRenderer.js
// module id = ./node_modules/react-sidenav/nav/NavRenderer.js
// module chunks = 0